package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import kotlinx.datetime.LocalDate

@Stable
data class AmortizationRow(
    val month: Int,
    val date: LocalDate,
    val payment: Double,
    val interest: Double,
    val principal: Double,
    val balance: Double
)
